// eslint-disable-next-line import/prefer-default-export
export const entetesHistorique = [
    {
        field: 'typeOperation',
        header: 'Évènement',
    },
    {
        field: 'dateOperation',
        header: 'Date événement',
    },
    { field: 'numeroEncodage', header: "Numéro d'encodage" },
    { field: 'marqueArme', header: 'Marque' },
    { field: 'modeleArme', header: 'Modèle' },
    { field: 'classementArme', header: 'Classement' },
];
